// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__TuHn_","background":"styles_background___DTA4","withText":"styles_withText__xfKFi","text":"styles_text__Ad_Yk"};